module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "releases"
    }
  }, [_c('heading', {
    attrs: {
      "text": _vm.$t('categories.releases'),
      "level": 2,
      "font": "astonished",
      "color": "red"
    }
  }), _vm._v(" "), _c('list', {
    ref: "list",
    attrs: {
      "scroll": false,
      "items": _vm.releases,
      "link": "album",
      "fields": ['album', 'band', 'type', 'date'],
      "type": "img"
    }
  }), _vm._v(" "), (_vm.$loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ab9d827"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/router-views/webzine/Releases.vue
// module id = 252
// module chunks = 0